import * as cart from '@shopify/theme-cart';
import { EventEmitter } from 'events';
import { theme } from '../../constants/defaults';

export default class Cart extends EventEmitter {
  getState() {
    return cart.getState().then(state => {
      this.updateCartCount(state.item_count);
      return state;
    });
  }

  addItem(variantId, options) {
    this.emit('adding');
    cart
      .addItem(variantId, options)
      .then(() => {
        if (theme.settings.ajaxCartEnabled) {
          // Open ajax cart
          // will update the cart count as well
          const modalNamespace = 'cart-modal';
          const modal = window.modalManager.idModalMap.get(modalNamespace);
          modal.show();
        } else {
          // Update cart count
          this.getState();
        }

        // Send added event
        this.emit('added');
      })
      .catch(response => {
        response.json().then(error => {
          this.emit('error_add_item', error);
        });
      });
  }

  async updateItem(key, options) {
    this.emit('updating');
    return cart
      .updateItem(key, options)
      .then(state => {
        this.updateCartCount(state.item_count);

        // Send updated event
        const updatedItem = state.items.find(item => item.key === key);
        this.emit('updated', updatedItem, state);
      })
      .catch(error => {
        this.emit('error_update_item', error);
      });
  }

  async removeItem(key) {
    this.emit('removing');
    return cart
      .removeItem(key)
      .then(state => {
        this.updateCartCount(state.item_count);

        // Send updated event to trigger cart update
        this.emit('updated', null, state);
      })
      .catch(error => {
        this.emit('error_remove_item', error);
      });
  }

  async updateNote(note) {
    return cart.updateNote(note).catch(error => {
      this.emit('error_update_note', error);
    });
  }

  updateCartCount(itemCount) {
    [...document.querySelectorAll('.js-cart-count')].forEach(cartCountEl => {
      cartCountEl.innerHTML = itemCount; // eslint-disable-line
    });
  }

  static getInstance() {
    if (!Cart.instance) {
      Cart.instance = new Cart();
    }
    return Cart.instance;
  }
}
